export default __webpack_public_path__ + "static/media/O-025.ac83c307.png";